'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasErrorMeta = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasErrorMeta = exports.hasErrorMeta = function hasErrorMeta(action) {
  return !!(0, _getIn2.default)(['meta', 'error'], action);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/action/operators/hasErrorMeta.js
// module id = 853
// module chunks = 2 3